module.exports = __webpack_public_path__ + "files/a78b9572db43b76262fe5652c47f0d5c.png";